module.exports = __webpack_public_path__ + "static/PEHC-logo-98f10329c835cbf200a4708bb7d550f3.png";